import React, { useEffect, useState } from "react";
import Constants from "../data/Constants";
import Input from "../components/Input";
import GoogleSignIn from "../components/GoogleSignIn";
import Seperator from "../components/Seperator";
import ThemeButton from "../components/ThemeButton";
import { auth, logInWithEmailAndPassword } from "../firebase";
import Alert from "../components/Alert";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
function Login(props) {
  const { theme } = props;

  const [user] = useAuthState(auth);

  const navigate = useNavigate();

  const [login, setLogin] = useState({
    email: null,
    password: null,
    passwordHidden: true,
  });

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      // maybe trigger a loading screen
      return;
    }
    if (user) navigate("/dashboard");
  }, [user, loading]);

  const handleInput = (e) => {
    setLogin({ ...login, [e.target.name]: e.target.value });
  };

  const handleLoginButton = async (e) => {
    if (login.email && login.password) {
      setError(false);
      setLoading(true);
      if (!(await logInWithEmailAndPassword(login.email, login.password))) {
        setError("Email or Password is incorrect");
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };
  return (
    <div className="grid grid-cols-1 sm:h-screen sm:grid-cols-5 ">
      <div className=" col-span-2 bg-primary content-center flex items-center justify-center p-2 sm:p-0">
        <img
          src={process.env.PUBLIC_URL + Constants.APP_LOGO.WHITE}
          className="w-auto sm:h-32 h-16 object-cover"
        />
        {/* <h1 className="font-medium text-4xl leading-tight text-center">
          Super Company
        </h1> */}
      </div>
      <div
        className="bg-gray-500 col-span-3 flex items-center justify-center"
        style={{
          background: theme.colors.body,
        }}
      >
        <div className="p-5 py-16 w-full max-w-md sm:border border-gray-300 rounded-lg flex flex-col gap-10">
          <h1 className="font-bold text-3xl leading-tight text-center">
            Admin Login
          </h1>
          {error && <Alert message={error} />}
          <TextField
            label="Email"
            placeholder="Enter Email Address"
            variant="filled"
            size="small"
            fullWidth
            name="email"
            type="email"
            onChange={handleInput}
          />
          <TextField
            label="Password"
            placeholder="Enter Password"
            variant="filled"
            size="small"
            fullWidth
            name="password"
            type={login.passwordHidden ? "password" : "text"}
            onChange={handleInput}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleLoginButton();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setLogin({
                        ...login,
                        passwordHidden: !login.passwordHidden,
                      });
                    }}
                    edge="end"
                  >
                    {login.passwordHidden ? (
                      <MdVisibilityOff />
                    ) : (
                      <MdVisibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {loading ? (
            <div className="w-full p-3  rounded-lg flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <Button
              variant="contained"
              size="large"
              onClick={handleLoginButton}
            >
              Login
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
